/* unplugin-vue-components disabled */import { render } from "./fujianshifanType.vue?vue&type=template&id=2bb5a1c5&scoped=true"
import script from "./fujianshifanType.vue?vue&type=script&lang=js"
export * from "./fujianshifanType.vue?vue&type=script&lang=js"

import "./fujianshifanType.vue?vue&type=style&index=0&id=2bb5a1c5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb5a1c5"]])

export default __exports__